module.exports = __webpack_public_path__ + "img/pngegg.1d6d05c4.png";